import {AggregateFunctionType} from "./types";
import FieldProto from "../../fields3/proto/field-proto";
import React from "react";

export class Aggregator {

    public type: AggregateFunctionType
    public field: FieldProto

    public value : number   // redefine in children if needed

    constructor(type: AggregateFunctionType, field: FieldProto) {

        this.type = type
        this.field = field

        this.value  = 0

    }

    public processItem(model:any):void {

        console.log("Not ovveridedn")

    }

    public render() {

        return (
            <div className="ui5-aggregator-value">
                not implemented
            </div>
        )

    }



}